import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

export default function DrillDownBreadcrumb({ crumbs, onCrumbClick }) {
  if (!crumbs || crumbs.length === 0) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5, fontSize: '0.85rem', mt: 0.5 }}>
      {crumbs.map((c, i) => (
        <React.Fragment key={i}>
          {i > 0 && <ChevronRight sx={{ fontSize: 14, color: 'text.secondary' }} />}
          {c.drillable ? (
            <Link
              component="button"
              type="button"
              onClick={() => onCrumbClick(i)}
              sx={{
                textDecoration: 'none',
                color: 'primary.main',
                fontSize: '0.85rem',
                '&:hover': { textDecoration: 'underline' },
              }}
            >
              {c.label}
            </Link>
          ) : (
            <Typography variant="body2" sx={{ color: 'text.primary', fontWeight: 600, fontSize: '0.85rem' }}>
              {c.label}
            </Typography>
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}
